<template>
  <HelpCenterLayout>
    <CareHealthBanner context="customer" />
    <component :is="homeComponent" />
  </HelpCenterLayout>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'

import CareHealthBanner from '@backmarket/nuxt-layer-care-platform/CareHealthBanner.vue'

import HelpCenterLayout from '~/scopes/help-center/layouts/HelpCenterLayout.vue'

import LegacyHelpCenterHome from '../components/LegacyHelpCenterHome/LegacyHelpCenterHome.vue'

import HelpCenterHome from './help/components/HelpCenterHome/HelpCenterHome.vue'

const { FF_ENABLE_NEW_HELP_CENTER } = useRuntimeConfig().public

const homeComponent = FF_ENABLE_NEW_HELP_CENTER
  ? HelpCenterHome
  : LegacyHelpCenterHome
</script>
